import {NgModule} from '@angular/core';
import {AbsenceApiModule, AbsenceConfiguration,} from '@cloudia-shared/apis/generated/absence-api';
import {
  DeviationApiModule,
  DeviationConfiguration,
} from '@cloudia-shared/apis/generated/allocation-deviation-api';
import {
  AllocationLogApiModule,
  AllocationLogConfiguration,
} from '@cloudia-shared/apis/generated/alloction-log-api';
import {
  CareerApiModule,
  CareerConfiguration,
} from '@cloudia-shared/apis/generated/career-plan-api';
import {
  CertificateApiModule,
  CertificateConfiguration,
} from '@cloudia-shared/apis/generated/certificate-api';
import {
  CurrencyConverterApiModule,
  CurrencyConverterConfiguration,
} from '@cloudia-shared/apis/generated/currency-converter-api';
import {CvIssueApiModule, CvIssueConfiguration,} from '@cloudia-shared/apis/generated/cv-issue-api';
import {
  DeliverableApiModule,
  DeliverableConfiguration,
} from '@cloudia-shared/apis/generated/deliverable-api';
import {
  EmployeeApiModule,
  EmployeeConfiguration,
} from '@cloudia-shared/apis/generated/employee-api';
import {
  EmployeeEducationApiModule,
  EmployeeEducationConfiguration,
} from '@cloudia-shared/apis/generated/employee-education-api';
import {
  EquipmentApiModule,
  EquipmentConfiguration,
} from '@cloudia-shared/apis/generated/equipment-api';
import {
  EuTimeTrackingApiModule,
  EuTimeTrackingConfiguration,
} from '@cloudia-shared/apis/generated/eu-time-tracking-api';
import {
  FeedbackProactiveApiModule,
  FeedbackProactiveConfiguration,
} from '@cloudia-shared/apis/generated/feedback-proactive-api';
import {
  GMAnalysisApiModule,
  GMAnalysisConfiguration,
} from '@cloudia-shared/apis/generated/gm-engine-analysis-api';
import {
  GMLiveApiModule,
  GMLiveConfiguration,
} from '@cloudia-shared/apis/generated/gm-engine-live-api';
import {HolidayApiModule, HolidayConfiguration,} from '@cloudia-shared/apis/generated/holiday-api';
import {ITBMApiModule, ITBMConfiguration,} from '@cloudia-shared/apis/generated/itbm-api';
import {
  KnowledgeSharingApiModule,
  KnowledgeSharingConfiguration,
} from '@cloudia-shared/apis/generated/knowledge-sharing-api';
import {
  OfferingApiModule,
  OfferingConfiguration,
} from '@cloudia-shared/apis/generated/offering-api';
import {BonusApiModule, BonusConfiguration,} from '@cloudia-shared/apis/generated/bonus-api';
import {PricingApiModule, PricingConfiguration,} from '@cloudia-shared/apis/generated/pricing-api';
import {ProjectApiModule, ProjectConfiguration,} from '@cloudia-shared/apis/generated/project-api';
import {
  ProjectCategoryApiModule,
  ProjectCategoryConfiguration,
} from '@cloudia-shared/apis/generated/project-category-api';
import {ReportApiModule, ReportConfiguration,} from '@cloudia-shared/apis/generated/reports-api';
import {
  ResourceApiModule,
  ResourceConfiguration,
} from '@cloudia-shared/apis/generated/resource-api';
import {
  SettingsApiModule,
  SettingsConfiguration,
} from '@cloudia-shared/apis/generated/settings-api';
import {
  SpecializationApiModule,
  SpecializationConfiguration,
} from '@cloudia-shared/apis/generated/specialization-api';
import {TimelogApiModule, TimelogConfiguration,} from '@cloudia-shared/apis/generated/timelog-api';
import {
  AiAgentApiModule,
  AiAgentConfiguration,
} from '@cloudia-shared/apis/generated/ai-agent-api';
import {
  WorkBlockerApiModule,
  WorkBlockerConfiguration,
} from '@cloudia-shared/apis/generated/work-blocker-api';
import {environment} from '../../environments/environment';
import {CloudiaServices} from './configuration/cloudia-services';
import {Configuration} from './configuration/configuration';
import {AllocationsApiModule, AllocationsConfiguration,} from './generated/allocation-api';
import {CommentApiModule, CommentConfiguration,} from './generated/comment-api';
import {
  CompetenceDomainApiModule,
  CompetenceDomainConfiguration,
} from './generated/competence-domain-api';
import {
  ConsultantBookingApiModule,
  ConsultantBookingConfiguration,
} from './generated/consultant-booking-api';
import {
  ConsultantCapabilityApiModule,
  ConsultantCapabilityConfiguration,
} from './generated/consultant-capability-api';
import {
  ConsultantSearchApiModule,
  ConsultantSearchConfiguration,
} from './generated/consultant-search-api';
import {CostCenterApiModule, CostCenterConfiguration,} from './generated/cost-center-api';
import {CSATApiModule, CSATConfiguration} from './generated/csat-api';
import {
  CustomerPortalApiModule,
  CustomerPortalConfiguration,
} from './generated/customer-portal-api';
import {CvExportApiModule, CvExportConfiguration,} from './generated/cv-export-api';
import {CvStudioApiModule, CvStudioConfiguration,} from '@cloudia-shared/apis/generated/cv-studio-api';
import {
  EmployeeCertificatesApiModule,
  EmployeeCertificatesConfiguration,
} from './generated/employee-certificates-api';
import {
  EmployeeLanguageApiModule,
  EmployeeLanguageConfiguration,
} from './generated/employee-language-api';
import {EmployeeSkillApiModule, EmployeeSkillConfiguration,} from './generated/employee-skill-api';
import {
  EmployeeSpecializationApiModule,
  EmployeeSpecializationConfiguration,
} from './generated/employee-specialization-api';
import {FeedbackApiModule, FeedbackConfiguration,} from './generated/feedback-api';
import {GMCommonApiModule, GMCommonConfiguration,} from './generated/gm-engine-common-api';
import {RankingJobApiModule, RankingJobConfiguration,} from './generated/jobs-api';
import {
  ProjectCustomerApiModule,
  ProjectCustomerConfiguration,
} from './generated/project-customers-api';
import {
  ProjectExperienceApiModule,
  ProjectExperienceConfiguration,
} from './generated/project-experience-api';
import {RankingApiModule, RankingConfiguration,} from './generated/ranking-api';
import {RecreateCvApiModule, RecreateCvConfiguration,} from './generated/recreate-cv-api';
import {ReportedHoursApiModule, ReportedHoursConfiguration,} from './generated/reported-hours-api';
import {
  SearchSuggestionApiModule,
  SearchSuggestionConfiguration,
} from './generated/search-suggestions-api';
import {
  ServiceNowAgentApiModule,
  ServiceNowAgentConfiguration,
} from './generated/servicenow-agent';
import {SkillApiModule, SkillConfiguration} from './generated/skill-api';
import {StaticObjectApiModule, StaticObjectConfiguration,} from './generated/static-object-api';
import {TaskApiModule, TaskConfiguration} from './generated/task-api';
import {TenantApiModule, TenantConfiguration} from './generated/tenant-api';
import {UserApiModule, UserConfiguration} from './generated/user-api';
import {DealApiModule, DealConfiguration,} from '@cloudia-shared/apis/generated/deals-api';
import {
  ProjectOverviewApiModule,
  ProjectOverviewConfiguration,
} from './generated/project-overview-api';
import {
  ProjectDeliveryStatusApiModule,
  ProjectDeliveryStatusConfiguration,
} from '@cloudia-shared/apis/generated/project-delivery-status-api';
import {
  EmDashboardApiModule,
  EmDashboardConfiguration,
} from '@cloudia-shared/apis/generated/em-dashboard-api';
import {
  SoftSkillApiModule,
  SoftSkillConfiguration
} from "@cloudia-shared/apis/generated/soft-skills-api";

const services = new CloudiaServices();

const getConfig = <T>(serviceKey: keyof CloudiaServices): T => {
  const service = services.get(serviceKey);

  if (environment.localBackend) {
    return new Configuration({
      basePath: `http://localhost:${service.port}/${service.basePath}`,
    }) as unknown as T;
  }

  return new Configuration({
    basePath: environment.apiUrl.replace('api/', `${service.basePath}`),
  }) as unknown as T;
};

@NgModule({
  imports: [
    AbsenceApiModule.forRoot(() =>
      getConfig<AbsenceConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    AllocationsApiModule.forRoot(() =>
      getConfig<AllocationsConfiguration>('BUSINESS_MANAGEMENT')
    ),
    AllocationLogApiModule.forRoot(() =>
      getConfig<AllocationLogConfiguration>('BUSINESS_MANAGEMENT')
    ),
    CareerApiModule.forRoot(() =>
      getConfig<CareerConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    CertificateApiModule.forRoot(() =>
      getConfig<CertificateConfiguration>('BUSINESS_MANAGEMENT')
    ),
    CommentApiModule.forRoot(() =>
      getConfig<CommentConfiguration>('SEARCH_ENGINE')
    ),
    CompetenceDomainApiModule.forRoot(() =>
      getConfig<CompetenceDomainConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ConsultantCapabilityApiModule.forRoot(() =>
      getConfig<ConsultantCapabilityConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    CSATApiModule.forRoot(() =>
      getConfig<CSATConfiguration>('CSAT_MANAGEMENT')
    ),
    FeedbackProactiveApiModule.forRoot(() =>
      getConfig<FeedbackProactiveConfiguration>('CSAT_MANAGEMENT')
    ),
    CurrencyConverterApiModule.forRoot(() =>
      getConfig<CurrencyConverterConfiguration>('BUSINESS_MANAGEMENT')
    ),
    CustomerPortalApiModule.forRoot(() =>
      getConfig<CustomerPortalConfiguration>('BUSINESS_MANAGEMENT')
    ),
    CvExportApiModule.forRoot(() =>
      getConfig<CvExportConfiguration>('SEARCH_ENGINE')
    ),
    CvStudioApiModule.forRoot(() =>
      getConfig<CvStudioConfiguration>('SEARCH_ENGINE')
    ),
    CvIssueApiModule.forRoot(() =>
      getConfig<CvIssueConfiguration>('BUSINESS_MANAGEMENT')
    ),
    DeviationApiModule.forRoot(() =>
      getConfig<DeviationConfiguration>('BUSINESS_MANAGEMENT')
    ),
    EmployeeEducationApiModule.forRoot(() =>
      getConfig<EmployeeEducationConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    EquipmentApiModule.forRoot(() =>
      getConfig<EquipmentConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    GMCommonApiModule.forRoot(() =>
      getConfig<GMCommonConfiguration>('GM_ENGINE')
    ),
    GMLiveApiModule.forRoot(() => getConfig<GMLiveConfiguration>('GM_ENGINE')),
    GMAnalysisApiModule.forRoot(() =>
      getConfig<GMAnalysisConfiguration>('GM_ENGINE')
    ),
    HolidayApiModule.forRoot(() =>
      getConfig<HolidayConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ProjectApiModule.forRoot(() =>
      getConfig<ProjectConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ProjectCategoryApiModule.forRoot(() =>
      getConfig<ProjectCategoryConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ProjectExperienceApiModule.forRoot(() =>
      getConfig<ProjectExperienceConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    RecreateCvApiModule.forRoot(() =>
      getConfig<RecreateCvConfiguration>('SEARCH_ENGINE')
    ),
    ReportedHoursApiModule.forRoot(() =>
      getConfig<ReportedHoursConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ResourceApiModule.forRoot(() =>
      getConfig<ResourceConfiguration>('BUSINESS_MANAGEMENT')
    ),
    SearchSuggestionApiModule.forRoot(() =>
      getConfig<SearchSuggestionConfiguration>('SEARCH_ENGINE')
    ),
    ConsultantSearchApiModule.forRoot(() =>
      getConfig<ConsultantSearchConfiguration>('SEARCH_ENGINE')
    ),
    SettingsApiModule.forRoot(() =>
      getConfig<SettingsConfiguration>('BUSINESS_MANAGEMENT')
    ),
    SpecializationApiModule.forRoot(() =>
      getConfig<SpecializationConfiguration>('BUSINESS_MANAGEMENT')
    ),
    StaticObjectApiModule.forRoot(() =>
      getConfig<StaticObjectConfiguration>('BUSINESS_MANAGEMENT')
    ),
    TenantApiModule.forRoot(() =>
      getConfig<TenantConfiguration>('BUSINESS_MANAGEMENT')
    ),
    UserApiModule.forRoot(() =>
      getConfig<UserConfiguration>('USER_MANAGEMENT')
    ),
    SkillApiModule.forRoot(() =>
      getConfig<SkillConfiguration>('BUSINESS_MANAGEMENT')
    ),
    EmployeeSkillApiModule.forRoot(() =>
      getConfig<EmployeeSkillConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    ProjectCustomerApiModule.forRoot(() =>
      getConfig<ProjectCustomerConfiguration>('BUSINESS_MANAGEMENT')
    ),
    TaskApiModule.forRoot(() =>
      getConfig<TaskConfiguration>('BUSINESS_MANAGEMENT')
    ),
    EmployeeLanguageApiModule.forRoot(() =>
      getConfig<EmployeeLanguageConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    EmployeeCertificatesApiModule.forRoot(() =>
      getConfig<EmployeeCertificatesConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    ConsultantBookingApiModule.forRoot(() =>
      getConfig<ConsultantBookingConfiguration>('SEARCH_ENGINE')
    ),
    CostCenterApiModule.forRoot(() =>
      getConfig<CostCenterConfiguration>('BUSINESS_MANAGEMENT')
    ),
    TimelogApiModule.forRoot(() =>
      getConfig<TimelogConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    AiAgentApiModule.forRoot(() =>
      getConfig<AiAgentConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    KnowledgeSharingApiModule.forRoot(() =>
      getConfig<KnowledgeSharingConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    EmployeeApiModule.forRoot(() =>
      getConfig<EmployeeConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    EmployeeSpecializationApiModule.forRoot(() =>
      getConfig<EmployeeSpecializationConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    RankingApiModule.forRoot(() => getConfig<RankingConfiguration>('RANKING')),
    RankingJobApiModule.forRoot(() =>
      getConfig<RankingJobConfiguration>('RANKING')
    ),
    ITBMApiModule.forRoot(() => getConfig<ITBMConfiguration>('ITBM')),
    FeedbackApiModule.forRoot(() =>
      getConfig<FeedbackConfiguration>('BUSINESS_MANAGEMENT')
    ),
    EuTimeTrackingApiModule.forRoot(() =>
      getConfig<EuTimeTrackingConfiguration>('EMPLOYEE_MANAGEMENT')
    ),
    BonusApiModule.forRoot(() =>
      getConfig<BonusConfiguration>('SEARCH_ENGINE')
    ),
    PricingApiModule.forRoot(() =>
      getConfig<PricingConfiguration>('SEARCH_ENGINE')
    ),
    ReportApiModule.forRoot(() =>
      getConfig<ReportConfiguration>('USER_MANAGEMENT')
    ),
    DeliverableApiModule.forRoot(() =>
      getConfig<DeliverableConfiguration>('BUSINESS_MANAGEMENT')
    ),
    OfferingApiModule.forRoot(() =>
      getConfig<OfferingConfiguration>('BUSINESS_MANAGEMENT')
    ),
    WorkBlockerApiModule.forRoot(() =>
      getConfig<WorkBlockerConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ServiceNowAgentApiModule.forRoot(() =>
      getConfig<ServiceNowAgentConfiguration>('RANKING')
    ),
    DealApiModule.forRoot(() =>
      getConfig<DealConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ProjectOverviewApiModule.forRoot(() =>
      getConfig<ProjectOverviewConfiguration>('BUSINESS_MANAGEMENT')
    ),
    ProjectDeliveryStatusApiModule.forRoot(() =>
      getConfig<ProjectDeliveryStatusConfiguration>('BUSINESS_MANAGEMENT')
    ),
    EmDashboardApiModule.forRoot(() =>
      getConfig<EmDashboardConfiguration>('BUSINESS_MANAGEMENT')
    ),
    SoftSkillApiModule.forRoot(() =>
      getConfig<SoftSkillConfiguration>('BUSINESS_MANAGEMENT')
    ),
  ],
})
export class CloudiaApisModule {
}
